export default __webpack_public_path__ + "static/media/pvilla1-4.ae0608d1.jpg";